import {createSlice} from '@reduxjs/toolkit';
import {login, refreshLogin, setBusinessPartner} from "../action/authActions";

const initialState = {
    loading: false,
    error: null,

    session: null,
    rememberMe: false,
    layoutPref: "Grid",
}

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        logOut: ( state ) => {
            state.session = null;
        },
        setRememberMe: ( state, {payload}) => {
            state.rememberMe = payload.isChecked;
        },
        setRefreshToken: (state, { payload }) => {
            state.session = {
                ...state.session,
                authToken: payload.token,
                refreshToken: payload.refresh_token
            }
        },
        setLayoutPref: (state, { payload }) => {
            state.layoutPref = payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(login.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(login.fulfilled, (state, { payload }) => {
                state.loading = false

                if(payload.orgs) {
                    state.orgSelect = payload;
                } else {

                    state.orgSelect = null;

                    const refreshToken = state.rememberMe ? payload.refreshToken : "";
                    state.session = {
                        ...payload,
                        refreshToken
                    };
                }
            })
            .addCase(login.rejected, (state, { payload }) => {
                state.loading = false
                state.error = payload
            })
            .addCase(refreshLogin.pending, (state) => {
                state.refreshing = true
                state.refreshError = null
            })
            .addCase(refreshLogin.fulfilled, (state, { payload }) => {
                state.refreshing = false;
            })
            .addCase(refreshLogin.rejected, (state, { payload }) => {
                state.refreshing = false
                state.refreshError = payload
            })
            .addCase(setBusinessPartner.pending, (state) => {
                state.refreshing = true
                state.refreshError = null
            })
            .addCase(setBusinessPartner.fulfilled, (state, { payload }) => {
                const updatedSession = {...state.session};
                updatedSession.bPartnerID = payload.id;
                updatedSession.businessName = payload.Name;
                updatedSession.businessCode = payload.Value;
                updatedSession.canBackOrder = payload["X_Allow_Back_Order"];
                updatedSession.priceListID = payload["M_PriceList_ID"]?.id
                updatedSession.discountSchemaID = payload["M_DiscountSchema_ID"]?.id;
                updatedSession.discountSchema = payload.discountSchema;
                state.session = updatedSession;
            })
            .addCase(setBusinessPartner.rejected, (state, { payload }) => {
                state.refreshing = false
                state.refreshError = payload
            })
    }
})

export const { logOut, setRememberMe, setRefreshToken, authTest, setLayoutPref } = authSlice.actions;
export default authSlice.reducer;
